import { type FC, type ReactNode } from "react";

// A quiet notice above content: a title, an optional line under it, and an
// optional action on the right. Nothing around it is dimmed.
export const InlineNotice: FC<{
  title: string;
  body?: string;
  action?: ReactNode;
}> = ({ title, body, action }) => (
  <div className="mb-[22px] flex items-center gap-3 rounded-lg border border-slate-200 bg-slate-50 py-[11px] pr-3 pl-3.5">
    <div className="min-w-0 flex-1">
      <div className="text-[13px] font-semibold text-slate-900">{title}</div>
      {body && <div className="mt-px text-xs text-slate-500">{body}</div>}
    </div>
    {action}
  </div>
);
